import { defineMessages, type IntlShape } from 'react-intl';

import evisortAvatarLogo from '~/assets/images/evisort-avatar-logo.svg';
import { User } from '~/eds/src/types/User';

export const STANDARD_AI_SERVICE_ACCOUNT_EMAIL = 'service-STDAI@evisort.com';

export const standardAiServiceAccountMessages = defineMessages({
  displayName: {
    id: 'StandardAiServiceAccount.displayName',
    defaultMessage: 'System',
    description:
      'Display name for the Standard AI service account in client-facing UI',
  },
  createdModelsTooltip: {
    id: 'StandardAiServiceAccount.createdModelsTooltip',
    defaultMessage: 'System created models',
    description:
      'Tooltip shown instead of the Standard AI service account email',
  },
});

export function isStandardAiServiceAccount(
  user?: {
    email?: string | null;
  } | null,
) {
  return (
    user?.email?.toLowerCase() ===
    STANDARD_AI_SERVICE_ACCOUNT_EMAIL.toLowerCase()
  );
}

export const EVISORT_AI: User = {
  id: '0',
  firstName: 'Evisort',
  lastName: 'AI',
  email: '',
  avatar: evisortAvatarLogo,
};

export const EVISORT: User = {
  id: '0',
  firstName: 'Evisort',
  lastName: '',
  email: '',
  avatar: evisortAvatarLogo,
};

export const getUsersConstans = (intl: IntlShape) => ({
  WORKDAY_ADMIN_DISABLED_ACTION_MESSAGE: intl.formatMessage({
    id: 'UseUsersConstants.workdayAdminDisabledActionMessage',
    defaultMessage:
      'This is managed in Workday. Contact your Workday admin for assistance',
    description:
      'Message shown when an action is disabled due to Workday admin management',
  }),
  WORKDAY_ADMIN_MANAGED_TEXT: intl.formatMessage({
    id: 'UseUsersConstants.workdayAdminManagedText',
    defaultMessage: 'This is managed in Workday by your Workday Admin',
    description: 'Text indicating that a feature is managed by Workday Admin',
  }),
});
